import { createContext } from 'react';
import { UsuarioProps } from '../../shared/types/usuarioProps';

export type AuthContextType = {
  currentUser: UsuarioProps | null;
  validateToken: () => void;
  signIn: (login: string, senha: string, forcar?: boolean) => Promise<boolean>;
  /* [28/10] Verdadeiro quando a recusa foi por SESSAO ATIVA (409), e nao por senha.
     E o que autoriza a tela de login a oferecer o "Encerrar a sessao anterior" - o
     botao nao pode aparecer numa recusa de credencial, senao vira pista de que aquele
     usuario existe. */
  sessaoBloqueada: boolean;
  // [22/10] Era `() => void` enquanto ninguém o chamava. Agora o "Sair" espera por ele:
  // o logout avisa o servidor, e quem chama precisa saber quando isso terminou.
  logout: () => Promise<void>;
  showLoading: boolean;
  setShowLoading: (state: boolean) => void;
  loginError: string | null;
};

export const AuthContext = createContext<AuthContextType>(null!);
